var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner_head_wrap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"banner_head text_center"},[_c('a',{attrs:{"href":_vm.activeNews.link,"target":"_blank"}},[_vm._v("\n                "+_vm._s(_vm.activeNews.text)+"\n            ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }